export const isMobile = () => {
  const match = window.matchMedia('(pointer:coarse)')
  return match && match.matches
}
export const isFirefox = navigator.userAgent.indexOf('Firefox') > -1
export const isSafari =
  /constructor/i.test(window.HTMLElement) ||
  (function (p) {
    return p.toString() === '[object SafariRemoteNotification]'
  })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification))
export const isIE = /*@cc_on!@*/ false || !!document.documentMode
export const isEdge = !isIE && !!window.StyleMedia
export const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime)
export const isValidEmail = (email) => {
  const emailPattern = /^\S+@\S+\.\S{2,}?$/
  if (email.toLowerCase().match(emailPattern)) {
    return true
  }
  return false
}
export const isValidPhone = (phone) => {
  const phonePattern = /^\+?[0-9,\ ]{8,}?$/
  if (phone.toLowerCase().match(phonePattern)) {
    return true
  }
  return false
}
